<template>
  <div id="login">
    <img src="/static/img/logo.png" class="center-block logo">

    <div class="text-center col-sm-12">
      <!-- login form -->
      <form @submit.prevent="signIn">
        <div class="input-group">
          <span class="input-group-addon"><i class="fa fa-envelope"></i></span>
         <input class="form-control" name="email" placeholder="Digite seu email" type="text" v-model="email">
        </div>

        <div class="input-group">
          <span class="input-group-addon"><i class="fa fa-lock"></i></span>
         <input class="form-control" name="password" placeholder="Digite sua senha" type="password" v-model="password">
        </div>
        <button type="submit" v-bind:class="'btn btn-primary btn-lg ' + loading">Entrar</button>
      </form>

      <!-- errors -->
      <div v-if=response class="text-red"><p class="vertical-5p lead">{{response}}</p></div>
    </div>
  </div>
</template>

<script>
import config from '../config'

export default {
  name: 'Login',
  data(router) {
    return {
      section: 'Login',
      loading: '',
      email: '',
      password: '',
      response: ''
    }
  },
  mounted() {
    this.toggleLoading()
  },
  methods: {
    signIn: function() {
      this.toggleLoading()
      let qs = require('querystring')
      if (this.email === '') {
        this.$alertify.alert('This is email')
      } else if (this.password === '') {
        this.$alertify.alert('This is password')
      } else {
        let usuario = qs.stringify({
          email: this.email,
          password: this.password
        })
        this.$store.dispatch('logoutUser')
        this.$store.dispatch('loginUser', usuario)
        .then(response => {
          window.localStorage.setItem('token', response.data.token)
          window.localStorage.setItem('monitores', response.data.projeto + '/monitores')
          window.localStorage.setItem('projeto', response.data.projeto)
          config.project = response.data.projeto
          this.$store.commit('SET_TOKEN', response.data.token)
          this.$store.commit('SET_USER', this.$store.state.Users.objeto)
          this.$store.dispatch('listTurnos')
          this.$store.dispatch('turnoAtual')
          this.$store.dispatch('listControladores')
          this.$store.dispatch('updateMonitorDia')
          return this.$router.push('/')
        })
        .catch(e => {
          this.$alertify.error('Usuário/Senha inválidos')
        })
      }
    },
    toggleLoading() {
      this.loading = this.loading === '' ? 'loading' : ''
    },
    resetResponse() {
      this.response = ''
    }
  }
}
</script>

<style>
#login {
  padding: 10em;
}

html,
body,
.container-table {
  height: 100%;
  background-color: #282b30 !important;
}
.container-table {
  display: table;
  color: white;
}
.vertical-center-row {
  display: table-cell;
  vertical-align: middle;
}
.vertical-20p {
  padding-top: 20%;
}
.vertical-10p {
  padding-top: 10%;
}
.vertical-5p {
  padding-top: 5%;
}
.logo {
  width: 15em;
  padding: 3em;
}

.input-group {
  padding-bottom: 2em;
  height: 4em;
  width: 100%;
}

.input-group span.input-group-addon {
  width: 2em;
  height: 4em;
}

@media (max-width: 1241px) {
  .input-group input {
    height: 4em;
  }
}
@media (min-width: 1242px) {
  form {
    padding-left: 20em;
    padding-right: 20em;
  }

  .input-group input {
    height: 6em;
  }
}

.input-group-addon i {
  height: 15px;
  width: 15px;
}
</style>



// WEBPACK FOOTER //
// Login.vue?adc865c4